/**
 *
 * key
 *
 */

 const key = 'ZGF0YUNvcHlDb21wbGV0ZWQ='

 export default key
 